import { translate } from "app/filters/i18nFilter";

export const getChartTooltipHeaders = () => [
    {
        position: 2,
        displayName: translate("website.analysis.traffic.and.engagement.chart.tooltip.change"),
    },
    { position: 0, displayName: "" },
    { position: 1, displayName: "" },
];
